<template lang="pug">
.sinan(v-if="localShowSinan")
  .sinan-left
    .left-img
      img(src="https://m.hellobike.com/resource/gallery/63/0egn6pzXEm.png?x-oss-process=image/quality,q_80", @click="closeSinan")
    div 您愿意推荐哈啰超级会员吗？
  .sinan-right(@click="openSinan")
    span 去评价
    img(src="https://m.hellobike.com/resource/gallery/63/FO90XQ2XR3.png?x-oss-process=image/quality,q_80")
</template>
<script>
export default {
  props: {
    showSinan: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localShowSinan: this.showSinan,
    };
  },
  watch: {
    showSinan(newVal) {
      this.localShowSinan = newVal;
    },
  },
  methods: {
    openSinan() {
      this.$emit('openSinan');
    },
    closeSinan() {
      this.localShowSinan = false;
      this.$emit('closeSinan');
    },
  },
};
</script>
<style lang="less" scoped>
.sinan {
  margin: 0 auto 0.08rem auto;
  width: 3.51rem;
  height: 0.4rem;
  background: #fff;
  display: flex;
  line-height: 0.4rem;
  justify-content: space-between;
  border-radius: 0.12rem;
  padding: 0 0.16rem 0 0.1rem;

  .sinan-left {
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.13rem;
    font-weight: 400;
    display: flex;

    .left-img {
      margin-top: 0.05rem;

      img {
        width: 0.18rem;
        height: 0.18rem;
      }
    }
  }

  .sinan-right {
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.14rem;
    font-weight: 600;

    img {
      margin-top: 0.07rem;
      margin-left: 0.02rem;
      width: 0.12rem;
      height: 0.12rem;
    }
  }
}
</style>
